import React from 'react';
import {
  Card,
  CardBody,
  Button
} from "@heroui/react";
import Link from 'next/link';

interface ActionButton {
  text: string;
  href: string;
  color?: "default" | "primary" | "secondary" | "success" | "warning" | "danger";
  variant?: "solid" | "bordered" | "light" | "flat" | "faded" | "shadow" | "ghost";
  icon?: React.ReactNode;
}

interface ActionButtonsCardProps {
  buttons: ActionButton[];
  className?: string;
}

/**
 * ActionButtonsCard - A reusable component for displaying a card with action buttons
 */
export default function ActionButtonsCard({
  buttons,
  className = ""
}: ActionButtonsCardProps) {
  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>
      <CardBody className="p-6 space-y-3">
        {buttons.map((button, index) => (
          <Button
            key={index}
            fullWidth
            color={button.color || "primary"}
            variant={button.variant || "solid"}
            as={Link}
            href={button.href}
            endContent={button.icon}
          >
            {button.text}
          </Button>
        ))}
      </CardBody>
    </Card>
  );
}